/**
 * Status command — show auth state and installed components
 */

import { readCredentials, isExpired } from "../auth/credentials.js";
import { detectAgents } from "../agents/detector.js";

export async function runStatus(): Promise<void> {
  console.log("Sailfish Autofix Status\n");

  // Auth status
  const creds = readCredentials();
  if (!creds) {
    console.log("🔑 Auth: Not authenticated");
    console.log("   Run: npx @sailfish-ai/autofix login\n");
  } else if (isExpired(creds)) {
    console.log("🔑 Auth: ⚠️  Expired");
    console.log("   Run: npx @sailfish-ai/autofix login\n");
  } else {
    console.log("🔑 Auth: ✅ Authenticated");
    console.log(`   Endpoint: ${creds.graphqlUrl}`);
    console.log(`   Source: ${creds.source}\n`);
  }

  // Agent detection
  const agents = detectAgents();
  console.log(`🤖 Detected Agents (${agents.length}):\n`);

  if (agents.length === 0) {
    console.log("   No supported agents detected.");
    console.log("   Supported: Claude Code, Cursor, Codex, Copilot, OpenCode, Windsurf, Gemini CLI, Goose\n");
  } else {
    for (const agent of agents) {
      const skillStatus = agent.hasSkill ? "✅ skill" : "❌ skill";
      const mcpStatus = agent.hasMcp ? "✅ mcp" : "❌ mcp";
      console.log(`   ${agent.name}: ${skillStatus} | ${mcpStatus}`);
    }
    console.log();
  }
}
